import { computed } from 'mobx';
import {
    TransactionApiFindAllTransactionsRequest,
    TransactionDto,
    TransactionDtoBrief,
} from 'src/generated-api-client';
import {
    bpmsResourcesManagerApi,
    transactionsApi,
} from 'src/services/apiServices';
import { ListFilter } from 'src/utils/FormHelper';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';
import { Pager } from 'src/utils/mobx/Pager';
import { Sorter } from 'src/utils/mobx/Sorter';
import { RequestHelper } from 'src/utils/RequestHelper';

export type TransactionsFilter =
    ListFilter<TransactionApiFindAllTransactionsRequest>;

export class TransactionsStoreClass extends BasicStore<
    TransactionDtoBrief,
    TransactionsFilter,
    unknown,
    unknown,
    TransactionDto
> {
    itemDetailsFormKey =
        'embedded:deployment:forms/bo/bo-01-transaction-info.json';

    pager = new Pager();
    sorter = new Sorter();
    filterCriteria: FilterCriteria<TransactionsFilter> = new FilterCriteria({});

    api: BasicStoreApi<TransactionDtoBrief, unknown, unknown, TransactionDto> =
        {
            loadList: async (...args: any[]) => {
                const options = RequestHelper.getOptionsFromArgs(args);
                const resp = await RequestHelper.unwrapFromAxiosPromise(
                    transactionsApi.findAllTransactions(
                        {
                            ...this.pager,
                            ...this.sorter,
                            ...this.filterCriteria.filter,
                        },
                        options,
                    ),
                );

                this.pager.setTotal(resp.totalElements || 0);

                return resp.content || [];
            },
            loadItemForm: (formKey: string, ...args) => {
                const options = RequestHelper.getOptionsFromArgs(args);

                return RequestHelper.unwrapFromAxiosPromise(
                    bpmsResourcesManagerApi.getForm({ formKey }, options),
                );
            },
            loadItem: (id: number, ...args) => {
                const options = RequestHelper.getOptionsFromArgs(args);

                return RequestHelper.unwrapFromAxiosPromise(
                    transactionsApi.getTransaction({ id }, options),
                );
            },
        };

    @computed get hasFilter() {
        return [
            this.filterCriteria.filter.filterCreatedAtFrom,
            this.filterCriteria.filter.filterCreatedAtTo,
            this.filterCriteria.filter.filterProcessedAtFrom,
            this.filterCriteria.filter.filterProcessedAtTo,
            this.filterCriteria.filter.filterSearch,
            this.filterCriteria.filter.filterStatuses,
            this.filterCriteria.filter.filterTypes,
        ].some((item) => Boolean(item));
    }
}

export const TransactionsStore = new TransactionsStoreClass();
